module.exports = __webpack_public_path__ + "img/editLangDialog.948a5ffb.jpg";